import { useAppSelector } from "../../../../../redux";
import { FlexColumn } from "../../../../Common/Styles";
import NewsFeedEmpty from "./NewsFeedEmpty";
import { PostCardContent } from "./PostCardContent";

export const PostCard = () => {
  const { ordered_post_ids, processed_posts, getNewsFeedPost_API_STATUS } =
    useAppSelector((state) => state.newsfeed);

  if (!ordered_post_ids.length && getNewsFeedPost_API_STATUS === "idle")
    return <NewsFeedEmpty />;

  return (
    <FlexColumn $gapInPx={8} id="newsfeedlisting">
      {ordered_post_ids.map((id, index) => {
        const post = processed_posts[id];
        if (!post) return null;
        return <PostCardContent key={id + index} postId={id} />;
      })}
    </FlexColumn>
  );
};
